import { cva } from "class-variance-authority";

import { FileCategory } from "./types";

import {
    FileCode,
    File as FileIcon,
    FileSpreadsheet,
    FileType,
    FolderArchive,
    Image,
    LucideIcon,
    Music,
} from "lucide-react";

export const fileUploadStateStyles = {
    default: "",
    dragActive: "setu:!border-primary setu:bg-accent",
    disabled: "setu:opacity-50 setu:cursor-not-allowed",
} as const;

export const fileUploadVariants = cva(
    `setu:relative
setu:flex setu:flex-col setu:items-center setu:justify-center setu:gap-6
setu:rounded-lg setu:!border-2 setu:border-dashed setu:!border-input
setu:bg-background setu:px-6 setu:py-8 setu:text-center setu:transition-colors
setu:w-full setu:cursor-pointer setu:group setu:p-4`,
    {
        variants: {
            state: fileUploadStateStyles,
            disabled: {
                true: "",
                false: "",
            },
        },
        defaultVariants: {
            state: "default",
            disabled: false,
        },
    }
);

// Extension to category mapping
export const EXTENSION_CATEGORY_MAP: Record<string, FileCategory> = {
    // Image extensions
    jpg: "image",
    jpeg: "image",
    png: "image",
    gif: "image",
    svg: "image",
    webp: "image",
    bmp: "image",
    ico: "image",
    heic: "image",
    tiff: "image",
    tif: "image",

    // Audio extensions
    mp3: "audio",
    wav: "audio",
    ogg: "audio",
    m4a: "audio",
    flac: "audio",
    aac: "audio",
    wma: "audio",
    aiff: "audio",

    // Code/JSON extensions
    json: "code",
    js: "code",
    jsx: "code",
    ts: "code",
    tsx: "code",
    py: "code",
    java: "code",
    cpp: "code",
    c: "code",
    cs: "code",
    go: "code",
    rb: "code",
    php: "code",
    html: "code",
    css: "code",
    scss: "code",
    xml: "code",
    yaml: "code",
    yml: "code",
    sh: "code",
    bash: "code",

    // PDF extensions
    pdf: "pdf",

    // Excel/Spreadsheet extensions
    xlsx: "excel",
    xls: "excel",
    csv: "excel",
    ods: "excel",
    numbers: "excel",

    // Zip/Archive extensions
    zip: "zip",
    rar: "zip",
    "7z": "zip",
    tar: "zip",
    gz: "zip",
    bz2: "zip",

    // Word/Document extensions
    doc: "word",
    docx: "word",
    txt: "word",
    rtf: "word",
    odt: "word",
    pages: "word",
} as const;

// Category to icon mapping
export const CATEGORY_ICON_MAP: Record<FileCategory, LucideIcon> = {
    image: Image,
    audio: Music,
    code: FileCode,
    pdf: FileIcon,
    excel: FileSpreadsheet,
    zip: FolderArchive,
    word: FileType,
    unknown: FileIcon,
} as const;
